import useSWR from 'swr'
import BillingService from '@forwardflow/services/BillingService'
import { QUERY_KEYS } from '@forwardflow/helpers/utils/constants'

export function useGetUsageSummary(
   period: string | null = 'this-month',
   startDate?: string,
   endDate?: string,
) {
   return useSWR(
      period ? [QUERY_KEYS.USAGE_SUMMARY, period, startDate, endDate] : null,
      () => BillingService.getUsageSummary(period!, startDate, endDate),
      {
         revalidateOnFocus: false,
      },
   )
}
